var React = require('react');

function SocialDiscourse (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1012 -0.00037384C18.6637 -0.00037384 24 5.48438 24 11.9959C24 18.5074 18.672 23.9884 12.1012 23.9884L0 24.0004V11.7896C0 5.28188 5.53125 -0.00037384 12.1012 -0.00037384ZM12.219 4.56188C9.6255 4.55813 7.22325 5.91338 5.883 8.13188C4.551 10.3391 4.49625 13.0886 5.7345 15.3506L4.39875 19.6084L9.19575 18.5344C11.9377 19.7606 15.1605 19.2101 17.3288 17.1439C19.5008 15.0934 20.1922 11.9171 19.0672 9.14813C17.9347 6.37088 15.2272 4.55813 12.2272 4.56188H12.219Z"}));
}

SocialDiscourse.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SocialDiscourse;

SocialDiscourse.default = SocialDiscourse;
